import { SaveButton } from "components/Buttons"
import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import {
  addDocument,
  deleteDocument,
  getDocumentList,
  hideDeleteDocumentModal,
  openDeleteDocumentModal,
  resetDocumentList,
  setSelectedFeature,
  updateDocument,
  updateDocumentOrder,
  updateDocumentStatus,
} from "store/actions"
import ReactDragListView from "react-drag-listview/lib/ReactDragListView"
import Table from "components/Table"
import documentListColumns from "./documentListColumns"
import Document from "./document"
import { mapDocumentToApi } from "../utils"
import ModalComponent from "components/Modals"
import PropTypes from "prop-types"
import { FormSection, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import SetupTab from "./setupTab"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"
import { LoadingIndicator } from "components/LoadingIndicator"

const DocumentList = props => {
  const [renderDocumentForm, setRenderDocumentForm] = useState(false)
  const [editableItem, setEditableItem] = useState(null)
  const [notificationModalIsOpen, setNotificationModalIsOpen] = useState(false)
  const [publishProps, setPublishProps] = useState(null)
  const selectedEventRef = useRef(props.selectedEvent)

  useEffect(() => {
    if (props.selectedEvent) {
      selectedEventRef.current = props.selectedEvent
    }
  }, [props.selectedEvent])
  const TABS = {
    SETUP: 1,
    DOCUMENTS: 2,
    HYPERLINKS: 3,
  }
  const [activeTab, setActiveTab] = useState(TABS.SETUP)
  const markAsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    props.getDocumentList({
      vendor_id: props.vendorId,
      menu_item_id: props.feature.id,
      ...(props?.selectedEvent ? { event_id: props.selectedEvent?.id } : {}),
    })
    return () => {
      props?.resetDocumentList()
    }
  }, [])

  const handleAddListItem = data => {
    if (!editableItem) {
      props.addDocument(
        mapDocumentToApi({
          ...data.document_feature_form,
          status: 0,
          vendor_id: props.vendorId,
          user_id: props.userId,
          menu_item_id: props.feature.id,
          event_id: props.selectedEvent?.id,
          menu_feature: 0,
          order: props.documentList.length + 1,
        })
      )
      setRenderDocumentForm(false)
    } else {
      props.updateDocument(
        editableItem.id,
        {
          menu_item_id: editableItem.menu_item_id,
        },
        mapDocumentToApi({
          ...data.document_feature_form,
          status: editableItem.status,
          vendor_id: editableItem.vendor_id,
          user_id: editableItem.user_id,
          menu_item_id: editableItem.menu_item_id,
          event_id: props.selectedEvent?.id,
          menu_feature: 0,
          order: editableItem.order,
        })
      )
      setEditableItem(null)
      setRenderDocumentForm(false)
    }
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const sortedList = [...props.documentList].sort(
        (a, b) => a.order - b.order
      )
      const modifiedList = [...sortedList]

      const item = modifiedList.splice(fromIndex, 1)[0]
      modifiedList.splice(toIndex, 0, item)

      const modifiedItems = modifiedList.map((item, index) => {
        if (item.id !== sortedList[index].id) {
          return { ...item, order: index + 1 }
        } else {
          return null
        }
      })

      modifiedItems.forEach(item => {
        if (item) {
          props.updateDocumentOrder(
            item.id,
            {
              menu_item_id: item.menu_item_id,
            },
            {
              vendor_id: item.vendor_id,
              status: item.status,
              name: item.name,
              user_id: item.user_id,
              menu_feature: 0,
              order: item.order,
              can_export: item.can_export,
              event_id: item.event_id,
              send_notification: 0,
            }
          )
        }
      })
    },
    nodeSelector: "tr",
    handleSelector: "tr",
    lineClassName: "dragDropLine",
  }

  const statusChangeHandler = (item, status) => {
    const selectedEvent = selectedEventRef?.current
    const featureId = item.id
    const menuItemId = {
      menu_item_id: item.menu_item_id,
    }
    const params = {
      vendor_id: item.vendor_id,
      status: status,
      name: item.name,
      user_id: item.user_id,
      menu_feature: 0,
      order: item.order,
      can_export: item.can_export,
      event_id: item.event_id,
      send_notification: 0,
    }
    if (status) {
      if (props.isEventFeature) {
        if (selectedEvent?.published) {
          setPublishProps({ featureId, menuItemId, params })
          setNotificationModalIsOpen(true)
        } else {
          props.updateDocumentStatus(featureId, menuItemId, params)
        }
      } else {
        setPublishProps({ featureId, menuItemId, params })
        setNotificationModalIsOpen(true)
      }
    } else {
      props.updateDocumentStatus(featureId, menuItemId, params)
    }
  }

  const editDocumentHandler = item => {
    setEditableItem(item)
    setRenderDocumentForm(true)
  }

  const [selectedListItem, setSelectedListItem] = useState()
  const handleDeleteItem = item => {
    setSelectedListItem(item)
    props.openDeleteDocumentModal()
  }

  const actions = [
    {
      name: "Edit",
      onClick: editDocumentHandler,
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: handleDeleteItem,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  return (
    <React.Fragment>
      {props?.listLoading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row>
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
            <Nav pills tabs>
              <NavLink
                className={markAsActive(TABS.SETUP)}
                onClick={() => setActiveTab(TABS.SETUP)}
              >
                Setup
              </NavLink>
              <NavLink
                className={markAsActive(TABS.DOCUMENTS)}
                onClick={() => setActiveTab(TABS.DOCUMENTS)}
              >
                Documents
              </NavLink>
              {props?.isEventFeature &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <NavLink
                    className={markAsActive(TABS.HYPERLINKS)}
                    onClick={() => setActiveTab(TABS.HYPERLINKS)}
                  >
                    Hyperlinks
                  </NavLink>
                )}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={TABS.SETUP} style={{ animation: "none" }}>
                <FormSection name={`${props.form}`}>
                  <SetupTab feature={props.feature} />
                </FormSection>
              </TabPane>
              <TabPane tabId={TABS.DOCUMENTS} style={{ animation: "none" }}>
                {renderDocumentForm ? (
                  <Document
                    feature={
                      editableItem
                        ? { entity_id: editableItem?.id, label: "" }
                        : { ...props.feature, label: "" }
                    }
                    handleAddListItem={handleAddListItem}
                    isListItem={true}
                    backButtonHandler={() => {
                      setRenderDocumentForm(false)
                      setEditableItem(null)
                    }}
                  />
                ) : (
                  <React.Fragment>
                    <Row className="mt-3">
                      <ReactDragListView {...dragProps}>
                        <Table
                          data={props.documentList}
                          columns={documentListColumns(statusChangeHandler)}
                          classes={"table align-middle"}
                          actions={actions}
                        />
                      </ReactDragListView>
                    </Row>
                    <Row>
                      <Col xl={3}>
                        <SaveButton
                          fullWidth={true}
                          type="button"
                          content="Add New Document"
                          onClick={() => setRenderDocumentForm(true)}
                        />
                      </Col>
                    </Row>
                  </React.Fragment>
                )}
              </TabPane>
              {props?.isEventFeature &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <TabPane
                    tabId={TABS.HYPERLINKS}
                    style={{ animation: "none" }}
                  >
                    <MenuFeatureHyperlinks
                      event_id={props?.selectedEvent?.id}
                      menu_feature={props?.feature}
                    />
                  </TabPane>
                )}
            </TabContent>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        title={`Delete Document - ${selectedListItem?.name}`}
        open={props.isDeleteDocumentModalOpen}
        onClose={props.hideDeleteDocumentModal}
      >
        <Row>
          <h5>Are you sure you want to delete this document?</h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={props.hideDeleteDocumentModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Delete"
              onClick={() =>
                props.deleteDocument(selectedListItem.id, {
                  menu_item_id: selectedListItem.menu_item_id,
                })
              }
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        open={notificationModalIsOpen}
        onClose={() => setNotificationModalIsOpen(false)}
      >
        <Row>
          <h5>
            Would you like to send a notification to your users that this
            document has been created?
          </h5>
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="No"
              onClick={() => {
                if (publishProps) {
                  const { featureId, menuItemId, params } = publishProps
                  props.updateDocumentStatus(featureId, menuItemId, params)
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Yes"
              onClick={() => {
                if (publishProps) {
                  const { featureId, menuItemId, params } = publishProps
                  props.updateDocumentStatus(featureId, menuItemId, {
                    ...params,
                    send_notification: 1,
                  })
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  documentList: state.Document.documentList,
  listLoading: state.Document.listLoading,
  isDeleteDocumentModalOpen: state.Document.isDeleteDocumentModalOpen,
  vendorConfig: state.clients.vendorConfig,
})

const mapDispatchToProps = dispatch => ({
  getDocumentList: values => dispatch(getDocumentList(values)),
  addDocument: values => dispatch(addDocument(values)),
  setSelectedFeature: values => dispatch(setSelectedFeature(values)),
  openDeleteDocumentModal: () => dispatch(openDeleteDocumentModal()),
  hideDeleteDocumentModal: () => dispatch(hideDeleteDocumentModal()),
  deleteDocument: (featureId, menuItemId) =>
    dispatch(deleteDocument(featureId, menuItemId)),
  updateDocument: (featureId, menuItemId, params) =>
    dispatch(updateDocument(featureId, menuItemId, params)),
  updateDocumentStatus: (featureId, menuItemId, params) =>
    dispatch(updateDocumentStatus(featureId, menuItemId, params)),
  updateDocumentOrder: (featureId, menuItemId, params) =>
    dispatch(updateDocumentOrder(featureId, menuItemId, params)),
  resetDocumentList: () => dispatch(resetDocumentList()),
})

DocumentList.propTypes = {
  feature: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.DOCUMENT_LIST })(DocumentList))
